import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { LoginPage } from "./routes/LoginPage";
import { RegisterPage } from "./routes/RegisterPage";
import { BoardsPage } from "./routes/BoardsPage";
import { BoardPage } from "./routes/BoardPage";
import { CardModal } from "./routes/CardModal";
import { TokensPage } from "./routes/TokensPage";
import { OrgsPage } from "./routes/OrgsPage";
import { AccountPage } from "./routes/AccountPage";
import { OAuthConsentPage } from "./routes/OAuthConsentPage";
import { Layout } from "./components/Layout";
import { AvatarProvider } from "./components/avatarMap";
import { useMe } from "./hooks/useMe";
import { returnPath } from "./util/returnPath";

export function App() {
  const { me, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          me ? <Navigate to={returnPath(location.state)} replace /> : <LoginPage />
        }
      />
      <Route
        path="/register"
        element={me ? <Navigate to="/boards" replace /> : <RegisterPage />}
      />
      {/* OAuth consent for remote MCP clients: signed-in, but outside the app chrome */}
      <Route
        path="/oauth/consent"
        element={
          me ? (
            <OAuthConsentPage />
          ) : (
            <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
          )
        }
      />
      <Route
        element={
          me ? (
            <AvatarProvider>
              <Layout />
            </AvatarProvider>
          ) : (
            // remember the board/card so signing back in returns there
            <Navigate
              to="/login"
              replace
              state={{ from: location.pathname + location.search }}
            />
          )
        }
      >
        <Route path="/boards" element={<BoardsPage />} />
        <Route path="/boards/:boardId" element={<BoardPage />}>
          <Route path="cards/:cardId" element={<CardModal />} />
        </Route>
        <Route path="/settings/orgs" element={<OrgsPage />} />
        <Route path="/settings/tokens" element={<TokensPage />} />
        <Route path="/settings/account" element={<AccountPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/boards" replace />} />
    </Routes>
  );
}